import React, { useEffect, useState } from "react";

import {
    Link,
    useNavigate
} from "react-router-dom";

import Swal from "sweetalert2";

import {
    FaEnvelope,
    FaLock,
    FaEye,
    FaEyeSlash,
    FaArrowRight,
    FaHome,
    FaGraduationCap,
    FaCheckCircle,
    FaArrowLeft,
    FaKey,
    FaShieldAlt
} from "react-icons/fa";

import {
    userForgotPasswordSendOtp,
    userForgotPasswordVerifyOtp,
    userForgotPasswordReset
} from "../config/userApi";


function ForgotPassword() {

    const navigate = useNavigate();


    /*
    |--------------------------------------------------------------------------
    | Steps
    |--------------------------------------------------------------------------
    |
    | 1 = Email
    | 2 = OTP
    | 3 = New Password
    |
    */

    const [step, setStep] = useState(1);


    /*
    |--------------------------------------------------------------------------
    | Email
    |--------------------------------------------------------------------------
    */

    const [email, setEmail] = useState("");


    /*
    |--------------------------------------------------------------------------
    | OTP
    |--------------------------------------------------------------------------
    */

    const [otp, setOtp] = useState("");


    /*
    |--------------------------------------------------------------------------
    | Password
    |--------------------------------------------------------------------------
    */

    const [password, setPassword] = useState("");


    const [passwordConfirmation, setPasswordConfirmation] =
        useState("");


    /*
    |--------------------------------------------------------------------------
    | Password Visibility
    |--------------------------------------------------------------------------
    */

    const [showPassword, setShowPassword] =
        useState(false);


    const [showConfirmPassword, setShowConfirmPassword] =
        useState(false);


    /*
    |--------------------------------------------------------------------------
    | Loading
    |--------------------------------------------------------------------------
    */

    const [loading, setLoading] =
        useState(false);


    /*
    |--------------------------------------------------------------------------
    | OTP Timer
    |--------------------------------------------------------------------------
    */

    const [otpTimer, setOtpTimer] =
        useState(0);


    /*
    |--------------------------------------------------------------------------
    | OTP Timer
    |--------------------------------------------------------------------------
    */

    useEffect(() => {

        if (otpTimer <= 0) {
            return;
        }


        const timer = setInterval(() => {

            setOtpTimer(
                (previous) =>
                    previous > 0
                        ? previous - 1
                        : 0
            );

        }, 1000);


        return () => clearInterval(timer);

    }, [otpTimer]);


    /*
    |--------------------------------------------------------------------------
    | Format Timer
    |--------------------------------------------------------------------------
    */

    const formatTimer = () => {

        const minutes =
            Math.floor(otpTimer / 60);

        const seconds =
            otpTimer % 60;


        return `${minutes}:${String(seconds).padStart(
            2,
            "0"
        )}`;
    };


    /*
    |--------------------------------------------------------------------------
    | Send OTP
    |--------------------------------------------------------------------------
    */

    const handleSendOtp = async (e) => {

        e.preventDefault();


        if (!email.trim()) {

            Swal.fire({
                icon: "warning",
                title: "Email Required",
                text: "Please enter your email address."
            });

            return;
        }


        const emailRegex =
            /^[^\s@]+@[^\s@]+\.[^\s@]+$/;


        if (!emailRegex.test(email.trim())) {

            Swal.fire({
                icon: "warning",
                title: "Invalid Email",
                text: "Please enter a valid email address."
            });

            return;
        }


        try {

            setLoading(true);


            const response =
                await userForgotPasswordSendOtp(
                    email.trim()
                );


            const responseText =
                await response.text();


            let data = {};


            try {

                data = JSON.parse(
                    responseText
                );

            } catch (error) {

                console.error(
                    "JSON Parse Error:",
                    error
                );


                Swal.fire({
                    icon: "error",
                    title: "Invalid API Response",
                    text:
                        "Laravel ने valid JSON response नहीं भेजा।"
                });

                return;
            }


            /*
            |--------------------------------------------------------------------------
            | Failed
            |--------------------------------------------------------------------------
            */

            if (!response.ok) {

                Swal.fire({
                    icon: "error",
                    title: "Unable to Send OTP",
                    text:
                        data.message ||
                        "Unable to send OTP."
                });

                return;
            }


            /*
            |--------------------------------------------------------------------------
            | Move To OTP Step
            |--------------------------------------------------------------------------
            */

            setStep(2);

            setOtp("");

            setOtpTimer(600);


            Swal.fire({

                icon: "success",

                title: "OTP Sent",

                text:
                    data.message ||
                    "OTP has been sent to your registered email address.",

                timer: 1800,

                showConfirmButton: false

            });


        } catch (error) {

            console.error(
                "Send OTP Error:",
                error
            );


            Swal.fire({

                icon: "error",

                title: "Connection Error",

                text:
                    error.message ||
                    "Unable to connect with server."

            });

        } finally {

            setLoading(false);

        }

    };


    /*
    |--------------------------------------------------------------------------
    | Verify OTP
    |--------------------------------------------------------------------------
    */

    const handleVerifyOtp = async (e) => {

        e.preventDefault();


        if (!otp.trim()) {

            Swal.fire({
                icon: "warning",
                title: "OTP Required",
                text: "Please enter the OTP received on your email."
            });

            return;
        }


        if (!/^\d{6}$/.test(otp.trim())) {

            Swal.fire({
                icon: "warning",
                title: "Invalid OTP",
                text: "OTP must contain exactly 6 digits."
            });

            return;
        }


        if (otpTimer <= 0) {

            Swal.fire({
                icon: "warning",
                title: "OTP Expired",
                text:
                    "This OTP has expired. Please request a new OTP."
            });

            return;
        }


        try {

            setLoading(true);


            const response =
                await userForgotPasswordVerifyOtp(
                    email.trim(),
                    otp.trim()
                );


            const responseText =
                await response.text();


            let data = {};


            try {

                data = JSON.parse(
                    responseText
                );

            } catch (error) {

                console.error(
                    "JSON Parse Error:",
                    error
                );


                Swal.fire({
                    icon: "error",
                    title: "Invalid API Response",
                    text:
                        "Laravel ने valid JSON response नहीं भेजा।"
                });

                return;
            }


            if (!response.ok) {

                Swal.fire({

                    icon: "error",

                    title: "Invalid OTP",

                    text:
                        data.message ||
                        "Invalid OTP."

                });

                return;
            }


            /*
            |--------------------------------------------------------------------------
            | OTP Verified
            |--------------------------------------------------------------------------
            */

            setStep(3);

            setOtpTimer(0);


            Swal.fire({

                icon: "success",

                title: "OTP Verified",

                text:
                    "You can now create your new password.",

                timer: 1500,

                showConfirmButton: false

            });


        } catch (error) {

            console.error(
                "Verify OTP Error:",
                error
            );


            Swal.fire({

                icon: "error",

                title: "Connection Error",

                text:
                    error.message ||
                    "Unable to connect with server."

            });

        } finally {

            setLoading(false);

        }

    };


    /*
    |--------------------------------------------------------------------------
    | Reset Password
    |--------------------------------------------------------------------------
    */

    const handleResetPassword = async (e) => {

        e.preventDefault();


        if (!password) {

            Swal.fire({
                icon: "warning",
                title: "Password Required",
                text: "Please enter your new password."
            });

            return;
        }


        if (password.length < 6) {

            Swal.fire({
                icon: "warning",
                title: "Password Too Short",
                text:
                    "Password must contain at least 6 characters."
            });

            return;
        }


        if (!passwordConfirmation) {

            Swal.fire({
                icon: "warning",
                title: "Confirm Password",
                text:
                    "Please confirm your new password."
            });

            return;
        }


        if (password !== passwordConfirmation) {

            Swal.fire({
                icon: "error",
                title: "Password Mismatch",
                text:
                    "New password and confirm password do not match."
            });

            return;
        }


        try {

            setLoading(true);


            const response =
                await userForgotPasswordReset(
                    email.trim(),
                    password,
                    passwordConfirmation
                );


            const responseText =
                await response.text();


            let data = {};


            try {

                data = JSON.parse(
                    responseText
                );

            } catch (error) {

                console.error(
                    "JSON Parse Error:",
                    error
                );


                Swal.fire({
                    icon: "error",
                    title: "Invalid API Response",
                    text:
                        "Laravel ने valid JSON response नहीं भेजा।"
                });

                return;
            }


            if (!response.ok) {

                Swal.fire({

                    icon: "error",

                    title: "Password Reset Failed",

                    text:
                        data.message ||
                        "Unable to reset password."

                });

                return;
            }


            /*
            |--------------------------------------------------------------------------
            | Password Successfully Changed
            |--------------------------------------------------------------------------
            */

            await Swal.fire({

                icon: "success",

                title: "Password Changed",

                text:
                    "Your password has been changed successfully. Please login with your new password.",

                confirmButtonText: "Go to Login"

            });


            /*
            |--------------------------------------------------------------------------
            | Clear State
            |--------------------------------------------------------------------------
            */

            setEmail("");

            setOtp("");

            setPassword("");

            setPasswordConfirmation("");

            setStep(1);


            /*
            |--------------------------------------------------------------------------
            | Go Login
            |--------------------------------------------------------------------------
            */

            navigate("/login");


        } catch (error) {

            console.error(
                "Reset Password Error:",
                error
            );


            Swal.fire({

                icon: "error",

                title: "Connection Error",

                text:
                    error.message ||
                    "Unable to connect with server."

            });

        } finally {

            setLoading(false);

        }

    };


    /*
    |--------------------------------------------------------------------------
    | Resend OTP
    |--------------------------------------------------------------------------
    */

    const handleResendOtp = async () => {

        if (otpTimer > 0 || loading) {
            return;
        }


        try {

            setLoading(true);


            const response =
                await userForgotPasswordSendOtp(
                    email.trim()
                );


            const responseText =
                await response.text();


            let data = {};


            try {

                data = JSON.parse(
                    responseText
                );

            } catch (error) {

                Swal.fire({
                    icon: "error",
                    title: "Invalid API Response",
                    text:
                        "Laravel ने valid JSON response नहीं भेजा।"
                });

                return;
            }


            if (!response.ok) {

                Swal.fire({

                    icon: "error",

                    title: "Unable to Resend OTP",

                    text:
                        data.message ||
                        "Unable to resend OTP."

                });

                return;
            }


            setOtp("");

            setOtpTimer(600);


            Swal.fire({

                icon: "success",

                title: "OTP Resent",

                text:
                    "A new OTP has been sent to your email.",

                timer: 1500,

                showConfirmButton: false

            });


        } catch (error) {

            Swal.fire({

                icon: "error",

                title: "Connection Error",

                text:
                    error.message ||
                    "Unable to connect with server."

            });

        } finally {

            setLoading(false);

        }

    };


    /*
    |--------------------------------------------------------------------------
    | Main Render
    |--------------------------------------------------------------------------
    */

    return (

        <div
            className="min-vh-100 d-flex align-items-center justify-content-center position-relative overflow-hidden py-4"
            style={{
                background:
                    "linear-gradient(rgba(255,255,255,0.38), rgba(255,255,255,0.48)), url('/assets/bgimage.png')",
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                backgroundAttachment: "fixed"
            }}
        >


            {/* ==============================================================
                BACKGROUND
            ============================================================== */}

            <div
                className="position-absolute rounded-circle bg-primary opacity-10"
                style={{
                    width: "320px",
                    height: "320px",
                    top: "-130px",
                    left: "-100px",
                    pointerEvents: "none"
                }}
            ></div>


            <div
                className="position-absolute rounded-circle bg-success opacity-10"
                style={{
                    width: "280px",
                    height: "280px",
                    bottom: "-120px",
                    right: "-80px",
                    pointerEvents: "none"
                }}
            ></div>


            {/* ==============================================================
                CONTAINER
            ============================================================== */}

            <div className="container position-relative">

                <div className="row justify-content-center">

                    <div className="col-12 col-sm-10 col-md-8 col-lg-5 col-xl-4">


                        {/* ==================================================
                            CARD
                        ================================================== */}

                        <div
                            className="card border-0 shadow-lg rounded-4 overflow-hidden"
                            style={{
                                background:
                                    "rgba(255,255,255,0.97)",
                                backdropFilter:
                                    "blur(10px)",
                                WebkitBackdropFilter:
                                    "blur(10px)"
                            }}
                        >


                            {/* ==================================================
                                BRAND
                            ================================================== */}

                            <div className="text-center pt-4 px-4">


                                <Link
                                    to="/"
                                    className="text-decoration-none"
                                >

                                    <div
                                        className="mx-auto mb-3 d-flex align-items-center justify-content-center rounded-4 shadow-sm"
                                        style={{
                                            width: "72px",
                                            height: "72px",
                                            background:
                                                "linear-gradient(135deg, #0d6efd, #0b5ed7)"
                                        }}
                                    >

                                        <FaGraduationCap
                                            className="text-white"
                                            size={36}
                                        />

                                    </div>

                                </Link>


                                <h2 className="fw-bold mb-1">

                                    Forgot Password

                                </h2>


                                <p className="text-muted mb-0">

                                    {step === 1 &&
                                        "Enter your registered email address."}

                                    {step === 2 &&
                                        "Enter the OTP sent to your email."}

                                    {step === 3 &&
                                        "Create your new password."}

                                </p>

                            </div>


                            {/* ==================================================
                                STEP INDICATOR
                            ================================================== */}

                            <div className="px-4 pt-4">

                                <div className="d-flex align-items-center justify-content-center">

                                    <div
                                        className={`rounded-circle d-flex align-items-center justify-content-center ${
                                            step >= 1
                                                ? "bg-primary text-white"
                                                : "bg-light text-muted"
                                        }`}
                                        style={{
                                            width: "34px",
                                            height: "34px"
                                        }}
                                    >

                                        <FaEnvelope size={13} />

                                    </div>


                                    <div
                                        className="flex-grow-1 mx-2"
                                        style={{
                                            height: "2px",
                                            background:
                                                step >= 2
                                                    ? "#0d6efd"
                                                    : "#dee2e6"
                                        }}
                                    ></div>


                                    <div
                                        className={`rounded-circle d-flex align-items-center justify-content-center ${
                                            step >= 2
                                                ? "bg-primary text-white"
                                                : "bg-light text-muted"
                                        }`}
                                        style={{
                                            width: "34px",
                                            height: "34px"
                                        }}
                                    >

                                        <FaKey size={13} />

                                    </div>


                                    <div
                                        className="flex-grow-1 mx-2"
                                        style={{
                                            height: "2px",
                                            background:
                                                step >= 3
                                                    ? "#0d6efd"
                                                    : "#dee2e6"
                                        }}
                                    ></div>


                                    <div
                                        className={`rounded-circle d-flex align-items-center justify-content-center ${
                                            step >= 3
                                                ? "bg-primary text-white"
                                                : "bg-light text-muted"
                                        }`}
                                        style={{
                                            width: "34px",
                                            height: "34px"
                                        }}
                                    >

                                        <FaLock size={13} />

                                    </div>

                                </div>


                                <div className="d-flex justify-content-between mt-2">

                                    <small className="text-muted">
                                        Email
                                    </small>

                                    <small className="text-muted">
                                        OTP
                                    </small>

                                    <small className="text-muted">
                                        Password
                                    </small>

                                </div>

                            </div>


                            {/* ==================================================
                                CARD BODY
                            ================================================== */}

                            <div className="card-body p-4">


                                {/* ==================================================
                                    STEP 1
                                ================================================== */}

                                {step === 1 && (

                                    <form
                                        onSubmit={handleSendOtp}
                                    >

                                        <div className="mb-4">

                                            <label
                                                className="form-label fw-semibold"
                                                htmlFor="email"
                                            >

                                                Email Address

                                            </label>


                                            <div className="input-group">

                                                <span className="input-group-text bg-light border-end-0">

                                                    <FaEnvelope
                                                        className="text-primary"
                                                        size={15}
                                                    />

                                                </span>


                                                <input
                                                    id="email"
                                                    type="email"
                                                    className="form-control bg-light border-start-0 py-2"
                                                    placeholder="Enter your registered email"
                                                    value={email}
                                                    onChange={(e) =>
                                                        setEmail(
                                                            e.target.value
                                                        )
                                                    }
                                                    disabled={loading}
                                                    autoComplete="email"
                                                    autoFocus
                                                />

                                            </div>


                                            <small className="text-muted d-block mt-2">

                                                OTP will be sent to your registered Gmail address.

                                            </small>

                                        </div>


                                        <button
                                            type="submit"
                                            className="btn btn-primary w-100 py-2 fw-semibold rounded-3 shadow-sm"
                                            disabled={loading}
                                        >

                                            {loading ? (

                                                <>

                                                    <span
                                                        className="spinner-border spinner-border-sm me-2"
                                                        role="status"
                                                    ></span>

                                                    Sending OTP...

                                                </>

                                            ) : (

                                                <>

                                                    Send OTP

                                                    <FaArrowRight
                                                        className="ms-2"
                                                        size={13}
                                                    />

                                                </>

                                            )}

                                        </button>

                                    </form>

                                )}


                                {/* ==================================================
                                    STEP 2
                                ================================================== */}

                                {step === 2 && (

                                    <form
                                        onSubmit={handleVerifyOtp}
                                    >

                                        <div className="text-center mb-3">

                                            <FaShieldAlt
                                                className="text-primary mb-2"
                                                size={30}
                                            />

                                            <p className="small text-muted mb-1">

                                                OTP sent to

                                            </p>

                                            <strong>

                                                {email}

                                            </strong>

                                        </div>


                                        <div className="mb-3">

                                            <label
                                                className="form-label fw-semibold"
                                                htmlFor="otp"
                                            >

                                                Enter 6 Digit OTP

                                            </label>


                                            <input
                                                id="otp"
                                                type="text"
                                                inputMode="numeric"
                                                maxLength={6}
                                                className="form-control bg-light text-center fw-bold"
                                                style={{
                                                    letterSpacing:
                                                        "8px",
                                                    fontSize:
                                                        "22px"
                                                }}
                                                placeholder="000000"
                                                value={otp}
                                                onChange={(e) => {

                                                    const value =
                                                        e.target.value
                                                            .replace(
                                                                /\D/g,
                                                                ""
                                                            )
                                                            .slice(
                                                                0,
                                                                6
                                                            );

                                                    setOtp(value);

                                                }}
                                                disabled={loading}
                                                autoFocus
                                            />

                                        </div>


                                        {otpTimer > 0 ? (

                                            <div className="text-center mb-3">

                                                <small className="text-muted">

                                                    OTP expires in{" "}

                                                    <strong className="text-primary">

                                                        {formatTimer()}

                                                    </strong>

                                                </small>

                                            </div>

                                        ) : (

                                            <div className="text-center mb-3">

                                                <button
                                                    type="button"
                                                    className="btn btn-link p-0 text-primary fw-semibold"
                                                    onClick={
                                                        handleResendOtp
                                                    }
                                                    disabled={loading}
                                                >

                                                    Resend OTP

                                                </button>

                                            </div>

                                        )}


                                        <button
                                            type="submit"
                                            className="btn btn-primary w-100 py-2 fw-semibold rounded-3 shadow-sm"
                                            disabled={
                                                loading ||
                                                otp.length !== 6 ||
                                                otpTimer <= 0
                                            }
                                        >

                                            {loading ? (

                                                <>

                                                    <span
                                                        className="spinner-border spinner-border-sm me-2"
                                                        role="status"
                                                    ></span>

                                                    Verifying...

                                                </>

                                            ) : (

                                                <>

                                                    Verify OTP

                                                    <FaArrowRight
                                                        className="ms-2"
                                                        size={13}
                                                    />

                                                </>

                                            )}

                                        </button>


                                        <div className="text-center mt-3">

                                            <button
                                                type="button"
                                                className="btn btn-link text-muted text-decoration-none small"
                                                onClick={() => {

                                                    setStep(1);

                                                    setOtp("");

                                                }}
                                                disabled={loading}
                                            >

                                                <FaArrowLeft
                                                    size={11}
                                                    className="me-1"
                                                />

                                                Change Email

                                            </button>

                                        </div>

                                    </form>

                                )}


                                {/* ==================================================
                                    STEP 3
                                ================================================== */}

                                {step === 3 && (

                                    <form
                                        onSubmit={
                                            handleResetPassword
                                        }
                                    >

                                        <div className="mb-3">

                                            <label
                                                className="form-label fw-semibold"
                                                htmlFor="newPassword"
                                            >

                                                New Password

                                            </label>


                                            <div className="input-group">

                                                <span className="input-group-text bg-light border-end-0">

                                                    <FaLock
                                                        className="text-primary"
                                                        size={15}
                                                    />

                                                </span>


                                                <input
                                                    id="newPassword"
                                                    type={
                                                        showPassword
                                                            ? "text"
                                                            : "password"
                                                    }
                                                    className="form-control bg-light border-start-0 border-end-0 py-2"
                                                    placeholder="Enter new password"
                                                    value={password}
                                                    onChange={(e) =>
                                                        setPassword(
                                                            e.target.value
                                                        )
                                                    }
                                                    disabled={loading}
                                                    autoComplete="new-password"
                                                    autoFocus
                                                />


                                                <button
                                                    type="button"
                                                    className="input-group-text bg-light border-start-0"
                                                    onClick={() =>
                                                        setShowPassword(
                                                            !showPassword
                                                        )
                                                    }
                                                    disabled={loading}
                                                >

                                                    {showPassword ? (

                                                        <FaEyeSlash
                                                            className="text-muted"
                                                            size={15}
                                                        />

                                                    ) : (

                                                        <FaEye
                                                            className="text-muted"
                                                            size={15}
                                                        />

                                                    )}

                                                </button>

                                            </div>

                                        </div>


                                        <div className="mb-4">

                                            <label
                                                className="form-label fw-semibold"
                                                htmlFor="confirmPassword"
                                            >

                                                Confirm Password

                                            </label>


                                            <div className="input-group">

                                                <span className="input-group-text bg-light border-end-0">

                                                    <FaLock
                                                        className="text-primary"
                                                        size={15}
                                                    />

                                                </span>


                                                <input
                                                    id="confirmPassword"
                                                    type={
                                                        showConfirmPassword
                                                            ? "text"
                                                            : "password"
                                                    }
                                                    className="form-control bg-light border-start-0 border-end-0 py-2"
                                                    placeholder="Confirm new password"
                                                    value={
                                                        passwordConfirmation
                                                    }
                                                    onChange={(e) =>
                                                        setPasswordConfirmation(
                                                            e.target.value
                                                        )
                                                    }
                                                    disabled={loading}
                                                    autoComplete="new-password"
                                                />


                                                <button
                                                    type="button"
                                                    className="input-group-text bg-light border-start-0"
                                                    onClick={() =>
                                                        setShowConfirmPassword(
                                                            !showConfirmPassword
                                                        )
                                                    }
                                                    disabled={loading}
                                                >

                                                    {showConfirmPassword ? (

                                                        <FaEyeSlash
                                                            className="text-muted"
                                                            size={15}
                                                        />

                                                    ) : (

                                                        <FaEye
                                                            className="text-muted"
                                                            size={15}
                                                        />

                                                    )}

                                                </button>

                                            </div>

                                        </div>


                                        <button
                                            type="submit"
                                            className="btn btn-primary w-100 py-2 fw-semibold rounded-3 shadow-sm"
                                            disabled={loading}
                                        >

                                            {loading ? (

                                                <>

                                                    <span
                                                        className="spinner-border spinner-border-sm me-2"
                                                        role="status"
                                                    ></span>

                                                    Changing Password...

                                                </>

                                            ) : (

                                                <>

                                                    Change Password

                                                    <FaCheckCircle
                                                        className="ms-2"
                                                        size={14}
                                                    />

                                                </>

                                            )}

                                        </button>

                                    </form>

                                )}


                                {/* ==================================================
                                    BACK TO LOGIN
                                ================================================== */}

                                <div className="text-center mt-4">

                                    <Link
                                        to="/login"
                                        className="text-decoration-none text-primary fw-semibold"
                                    >

                                        <FaArrowLeft
                                            size={12}
                                            className="me-2"
                                        />

                                        Back to Login

                                    </Link>

                                </div>


                                {/* ==================================================
                                    BACK HOME
                                ================================================== */}

                                <div className="text-center mt-3">

                                    <Link
                                        to="/"
                                        className="text-decoration-none text-muted small"
                                    >

                                        <FaHome
                                            size={12}
                                            className="me-1"
                                        />

                                        Back to Home

                                    </Link>

                                </div>


                            </div>


                            {/* ==================================================
                                FOOTER
                            ================================================== */}

                            <div className="bg-light border-top text-center py-3 px-3">

                                <div className="d-flex justify-content-center align-items-center gap-2">

                                    <FaCheckCircle
                                        className="text-success"
                                        size={13}
                                    />

                                    <small className="text-muted">

                                        Secure &amp; trusted learning platform

                                    </small>

                                </div>

                            </div>

                        </div>


                        {/* ==================================================
                            COPYRIGHT
                        ================================================== */}

                        <div className="text-center mt-3">

                            <small
                                className="text-white fw-semibold"
                                style={{
                                    textShadow:
                                        "0 1px 4px rgba(0,0,0,0.7)"
                                }}
                            >

                                © 2026 Homoeoadda. All rights reserved.

                            </small>

                        </div>

                    </div>

                </div>

            </div>

        </div>

    );

}


export default ForgotPassword;